import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import {
  selectDamagesAdditionalData,
  selectArePreviousDamagePresent,
  selectIsVehicleNotWorking,
  selectIsReplacementVehicleRequired,
  selectAreOtherDamagesPresent,
} from "../damages.selectors";
import {
  setAreOtherDamagesPresent,
  setPreviousDamagePresent,
  setIsReplacementVehicleRequired,
  setIsVehicleWorking,
} from "../damages.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<
  SimpleFormSchemaComponents | ComplexFormSchemaComponents
> = {
  formId: FormId.DAMAGES_ADDITIONAL,
  selector: selectDamagesAdditionalData,
  content: [
    {
      title: "Informacje dodatkowe",
      sections: [
        {
          id: "additional-form-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_PREVIOUS_DAMAGE_PRESENT,
              label:
                "Czy pojazd przed zdarzeniem posiadał jakieś inne widoczne uszkodzenia?",
              required: true,
              onChange: setPreviousDamagePresent,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-2",
          isVisible: selectArePreviousDamagePresent,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.PREVIOUS_DAMAGE_DESCRIPTION,
              label: "Opis wcześniejszych uszkodzeń",
              required: true,
              limit: 100,
              placeholder: "Opisz uszkodzenia swojego pojazdu",
            },
          ],
        },
        {
          id: "additional-form-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.AIRBAGS_DEPLOYED,
              label: "Czy zadziałały poduszki powietrzne?",
              required: true,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.IS_VEHICLE_WORKING,
              label:
                "Czy pojazd jest jezdny i można się nim bezpiecznie poruszać?",
              required: true,
              tooltip:
                "Art. 66. 1 DU rok 1997 numer 98 poz. 602 Kodeks drogowy - Prawo o ruchu drogowym",
              onChange: setIsVehicleWorking,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-5",
          isVisible: selectIsVehicleNotWorking,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.IS_REPLACEMENT_VEHICLE_REQUIRED,
              label: "Czy wymagany jest pojazd zastępczy?",
              onChange: setIsReplacementVehicleRequired,
              required: true,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-6",
          isVisible: selectIsReplacementVehicleRequired,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.COPY,
              id: "copy",
              content: [
                "W związku ze szkodą z OC sprawcy, jeśli Państwa pojazd nie jest jezdny, możemy zapewnić dla Pana/Pani pojazd zastępczy na czas niezbędny do naprawy. Jeśli jest Pan/Pani zainteresowana/ny wynajmem takiego auta po zarejestrowaniu i nadaniu nr szkody wraz z potwierdzeniem przyjęcia otrzyma Pan/Pani dane współpracującej wypożyczalni. Prosimy o kontakt pod podany nr telefonu i powołanie się na nr szkody.",
                "Informujemy również, że w zamian za odstąpienie od w/w wynajmu przysługuje Panu/Pani ekwiwalent pieniężny w wysokości ustalonej z Likwidatorem szkody. Wypłata takiego świadczenia możliwa jest po podpisaniu stosownej ugody wysłanej do Państwa po wyrażeniu zainteresowania taką formą rekompensaty.",
              ],
            },
          ],
        },
        {
          id: "additional-form-data-7",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_OTHER_DAMAGES_PRESENT,
              onChange: setAreOtherDamagesPresent,
              label:
                "Czy powstały inne szkody rzeczowe poza uszkodzonym pojazdem?",
              required: true,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "additional-form-data-8",
          isVisible: selectAreOtherDamagesPresent,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.OTHER_DAMAGES_DESCRIPTION,
              label: "",
              required: true,
              limit: 100,
              placeholder: "Opisz inne szkody rzeczowe",
            },
          ],
        },
      ],
    },
  ],
};
